export default __webpack_public_path__ + "static/media/2 - Компьютерный класс.7086031a.jpg";